import { render, staticRenderFns } from "./BrandTagSelect.vue?vue&type=template&id=3baed8b4&scoped=true&"
import script from "./BrandTagSelect.vue?vue&type=script&lang=js&"
export * from "./BrandTagSelect.vue?vue&type=script&lang=js&"
import style0 from "./BrandTagSelect.vue?vue&type=style&index=0&id=3baed8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baed8b4",
  null
  
)

export default component.exports